import {Button, Carousel, Col, Collapse, Row} from "antd";
import React, {useMemo, useState} from "react";
import {Swiper} from "antd-mobile";
import CollapsePanel from "antd/es/collapse/CollapsePanel";
import {CheckCircleOutlined} from "@ant-design/icons";

const MembershipPlansMobile = ({pageContent, subscriptionType}) => {
    const [selectedIndex, setSelectedIndex] = useState(2);
    const onIndexChange = (index) => setSelectedIndex(index);

    const selectedTier = useMemo(() => {
        return pageContent.membershipsTiers[selectedIndex];
    }, [selectedIndex, pageContent]);

    return (
        <>
            <Swiper
                className="membership-plans-slider"
                slideSize={60}
                trackOffset={20}
                defaultIndex={selectedIndex}
                stuckAtBoundary={false}
                onIndexChange={onIndexChange}
            >
                {pageContent.membershipsTiers.map((tier,i) => (
                    <Swiper.Item key={i}>
                        <div className={"membership-tier-box "+(tier.best ? 'best-option' : '')} >
                            <div className={'tier-title'}>{tier.name}</div>
                            <div className={'tier-price mar-bot-5'}>{tier.price}</div>
                            <Button
                                className={"width-66 "+(tier.btn_class)}
                                disabled={!tier.btn_active}
                                href={tier.btn_link}
                            >
                                {tier.btn_text}
                            </Button>
                        </div>
                    </Swiper.Item>
                ))}
            </Swiper>


            <Collapse defaultActiveKey={pageContent.membershipOptions.map((option,i) => i)} ghost expandIconPosition={"end"}>
                {pageContent.membershipOptions.map((option,i) => (
                    <CollapsePanel header={<span className="accordian-title">{option.name}</span>} key={i}>
                        {option.options.map((option,j) => (
                            <Row key={j} className={"pad-5 " + (j%2==0 ? '' : ' row-colored ')}>
                                <Col span={18} className="tier-row-title membership-row-cell pad-left-10">
                                    {option.name}
                                </Col>
                                {option.tiers.map((tier,k) => (k === selectedIndex) && (
                                    <Col key={k} span={6} className="tier-price">
                                        {tier === true && (
                                            <CheckCircleOutlined className="icon24 iconCovrBlue" />
                                        )}
                                        {tier === false && "--"}
                                        {tier !== true && tier !== false && tier}
                                    </Col>
                                ))}
                            </Row>
                        ))}
                    </CollapsePanel>
                ))}
            </Collapse>
            <div className="mar-top-20" />
            <div className={"mar-top-20 membership-tier-box "+(selectedTier.best ? 'best-option' : '')} >
                <div className={'tier-title'}>{selectedTier.name}</div>
                <div className={'tier-price mar-bot-5'}>{selectedTier.price}</div>
                <Button
                    className={"width-66 "+(selectedTier.btn_class)}
                    disabled={!selectedTier.btn_active}
                    href={selectedTier.btn_link}
                >
                    {selectedTier.btn_text}
                </Button>
            </div>
        </>
    );
};

export default MembershipPlansMobile;